import React from "react";
import { Box, Typography, Stepper, Step, StepLabel, StepIcon } from "@mui/material";
import { styled } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import AutorenewIcon from "@mui/icons-material/Autorenew";

const agentSteps = ["Retriever", "Planner", "Judge"];

const agentColors = {
  Retriever: "#3ad0de",
  Planner: "#D183C9",
  Judge: "#7595ff"
};

const ColorStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  borderRadius: '50%',
  backgroundColor: ownerState.completed 
    ? agentColors[ownerState.label]
    : ownerState.active 
    ? `${agentColors[ownerState.label]}44`
    : '#2a2a3e',
  border: `2px solid ${ownerState.active ? agentColors[ownerState.label] : '#444'}`,
  color: ownerState.completed || ownerState.active ? '#fff' : '#666',
  animation: ownerState.active ? 'spin 2s linear infinite' : 'none',
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' }
  }
}));

function ColorStepIcon(props) {
  const { active, completed, className, icon } = props;
  const label = agentSteps[Number(icon) - 1];

  return (
    <ColorStepIconRoot ownerState={{ completed, active, label }} className={className}>
      {completed ? (
        <CheckCircleIcon />
      ) : active ? (
        <AutorenewIcon />
      ) : (
        <RadioButtonUncheckedIcon />
      )}
    </ColorStepIconRoot>
  );
}

const WorkflowProgress = ({ trace, isRunning }) => {
  if (!isRunning && trace.length === 0) return null;

  // Determine which step is active
  const activeStep = trace.length > 0 ? trace.length - 1 : 0;
  const completedSteps = trace.filter(t => t.done).length;

  return (
    <Box sx={{ mb: 3 }}>
      <Stepper 
        activeStep={activeStep} 
        alternativeLabel
        sx={{
          '& .MuiStepLabel-label': {
            color: '#aaa',
            fontWeight: 500
          },
          '& .MuiStepLabel-label.Mui-active': {
            color: '#fff',
            fontWeight: 600
          },
          '& .MuiStepLabel-label.Mui-completed': {
            color: '#3ad0de',
            fontWeight: 600
          },
          '& .MuiStepConnector-line': {
            borderColor: '#444',
            borderWidth: 2
          },
          '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
            borderColor: '#3ad0de'
          }
        }}
      >
        {agentSteps.map((label, index) => {
          const isCompleted = trace[index]?.done;
          const isActive = !isCompleted && index === trace.length - 1 && isRunning;
          
          return (
            <Step key={label} completed={isCompleted}>
              <StepLabel StepIconComponent={ColorStepIcon}>
                <Typography 
                  variant="body2"
                  sx={{
                    color: isCompleted 
                      ? agentColors[label]
                      : isActive 
                      ? '#fff'
                      : '#666',
                    fontWeight: isActive || isCompleted ? 600 : 400
                  }}
                >
                  {label}
                </Typography>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
};

export default WorkflowProgress;
